import { render, staticRenderFns } from "./ProjectsList.vue?vue&type=template&id=44860bae&"
import script from "./ProjectsList.vue?vue&type=script&lang=js&"
export * from "./ProjectsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44860bae')) {
      api.createRecord('44860bae', component.options)
    } else {
      api.reload('44860bae', component.options)
    }
    module.hot.accept("./ProjectsList.vue?vue&type=template&id=44860bae&", function () {
      api.rerender('44860bae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/realEstate/ProjectsList.vue"
export default component.exports